import { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconButton } from 'shared/ui/buttons/iconButtons/iconButton';
import { IconButtonStyles } from '../buttons/iconButtons/iconButton/iconButton';
import { SmallCircleButton } from '../buttons/iconButtons/circleButtons';
import { FULL_SLOT } from 'shared/consts';
import { CircleButtonContainer, Counter } from './style';

export interface IMenuItem {
	link: string;
	iconSrc: string;
	iconSrcActive: string;
	iconButtonStyles?: IconButtonStyles;
	counter?: number;
}

export const MenuItem: FC<IMenuItem> = ({
	iconSrc,
	link,
	iconSrcActive,
	iconButtonStyles,
	counter = 0,
}) => {
	const [isActive, setActive] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		if (link === location.pathname) {
			setActive(true);
		} else {
			setActive(false);
		}
	}, [link, location.pathname]);

	return (
		<Link to={link} role="menu-item">
			<li>
				{counter > 0 && (
					<Counter>
						<CircleButtonContainer>
							<SmallCircleButton color={FULL_SLOT} size="20px">
								{counter}
							</SmallCircleButton>
						</CircleButtonContainer>
					</Counter>
				)}
				<IconButton
					iconSrc={isActive ? iconSrcActive : iconSrc}
					isPrimary={isActive}
					styles={{ ...iconButtonStyles, background: 'white' }}
				/>
			</li>
		</Link>
	);
};
